import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBackIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.07545 11.137L11.7921 15.8453C11.8696 15.9234 11.9617 15.9854 12.0633 16.0277C12.1648 16.07 12.2738 16.0918 12.3838 16.0918C12.4938 16.0918 12.6027 16.07 12.7043 16.0277C12.8058 15.9854 12.898 15.9234 12.9754 15.8453C13.1307 15.6892 13.2178 15.478 13.2178 15.2578C13.2178 15.0376 13.1307 14.8264 12.9754 14.6703L8.85045 10.5036L12.9754 6.37863C13.1307 6.2225 13.2178 6.01129 13.2178 5.79113C13.2178 5.57098 13.1307 5.35977 12.9754 5.20363C12.8983 5.12489 12.8062 5.06225 12.7047 5.01934C12.6031 4.97642 12.494 4.95409 12.3838 4.95363C12.2735 4.95409 12.1645 4.97642 12.0629 5.01934C11.9613 5.06225 11.8693 5.12489 11.7921 5.20363L7.07545 9.91196C6.99086 9.99 6.92335 10.0847 6.87718 10.1901C6.83101 10.2955 6.80717 10.4094 6.80717 10.5245C6.80717 10.6395 6.83101 10.7534 6.87718 10.8588C6.92335 10.9642 6.99086 11.0589 7.07545 11.137Z",
		fill: "#EDEEF0"
	})
});
export { SvgBackIcon as ReactComponent };
